<template>   
  <v-input class="hdms-field mt-2" v-bind="$attrs">        
        <number-field-factor :positiveOnly="true" :round="true" v-model="degVal" @input="inputEPSG4326Value" hide-details >        
          <template #append-outer>°</template>
        </number-field-factor>
        <number-field-factor :positiveOnly="true" :round="true" v-model="minVal" @input="inputEPSG4326Value" hide-details class="ml-1" >
          <template #append-outer>′</template>
        </number-field-factor>
        <number-field-factor :positiveOnly="true" :round="true" v-model="secVal" @input="inputEPSG4326Value" hide-details class="ml-1" >
          <template #append-outer><span style="white-space:nowrap">′′</span></template>
        </number-field-factor>
        <v-select :items="orientationItems" v-model="orientation" @input="inputEPSG4326Value" hide-details class="ml-1" style="flex-grow:0;width:25px" ></v-select>
        <template #label>  
          <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: -7px; right: auto; position: absolute;transform: translateY(-18px) scale(.75);">{{$attrs.label}}</label>           
        </template>        
    </v-input>
</template>
<script lang="ts">        
  import Vue from 'vue'  
  import Component from 'vue-class-component'  
  import {toStringHDMS,Coordinate}  from 'ol/coordinate'
import { Watch } from 'vue-property-decorator'

  @Component({
    name: 'LatLngHdmsField', 
    props:{                          
      value:{
        type:Number,
        default:0
      },
      isLat:{
        type:Boolean,
        default:true,
        required:true
      }
    }
  })
  
  export default class LatLngHdmsField extends Vue {  
    private value!:number     
    private isLat!:boolean

    private degVal = 0
    private minVal = 0
    private secVal = 0
    private orientation = ""

    
    get orientationItems(){
      return this.isLat?["N","S"]:["E","W"]
    }

    mounted(){
      this.initData()
    }

    @Watch('value')
    onValueChange(){
      this.initData()      
    }
    

    initData()  {      
      const hdms = toStringHDMS([this.isLat?1:this.value,this.isLat?this.value:1])
      const hdmsPart = hdms.split(' ')
      this.degVal = this.isLat?Number.parseInt(hdmsPart[0].replace('°','')):Number.parseInt(hdmsPart[4].replace('°',''))
      this.minVal = this.isLat?Number.parseInt(hdmsPart[1].replace('′','')):Number.parseInt(hdmsPart[5].replace('′',''))
      this.secVal = this.isLat?Number.parseInt(hdmsPart[2].replace('″','')):Number.parseInt(hdmsPart[6].replace('″',''))
      this.orientation = this.isLat?hdmsPart[3]:hdmsPart[7]      
    }  

    updateValue() {         
      const min =  (isNaN(this.minVal)?0:this.minVal) / 60.0
      const sec = (isNaN(this.secVal)?0:this.secVal) / 3600.0
      let newVal = ((isNaN(this.degVal)?0:this.degVal) + min + sec) * ((this.orientation == 'S' || this.orientation == 'W')?-1:1)
      if(this.isLat)
      {
        if(newVal > 90) {
          newVal = 90
          this.degVal = 90        
          this.minVal = 0
          this.secVal = 0
        }
        else if(newVal < -90){
          newVal = -90
          this.degVal = 90        
          this.minVal = 0
          this.secVal = 0
        } 
      } 
      else {
        if(newVal > 180) {
          newVal = 180
          this.degVal = 180          
          this.minVal = 0
          this.secVal = 0
        }
        else if(newVal < -180) {
          newVal = -180
          this.degVal = 180
          this.minVal = 0
          this.secVal = 0
        }
      } 
      this.$emit('input',newVal)
    }

    //'DD°MM′SS″'              
    inputEPSG4326Value(newV:any) {
      this.$nextTick(() => {
        this.updateValue()
      })      
    }
  }
</script>
<style>
.hdms-field input,.hdms-field select{
 text-align: right;
}
</style>
